import React, { useEffect } from "react";
import { publicTheme } from "./themes";
import { dashboardTheme } from "./themes";
import { Switch } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";
import { AppProvider } from "./modules/app/context";
import { AuthProvider } from "./modules/auth/context";
import Public from "./modules/app/components/Public";
import Dashboard from "./modules/app/components/Dashboard";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./assets/font-icons/style.css";
import GoogleAnalytics from "react-ga";
import { ReactQueryConfig, ReactQueryConfigProvider } from "react-query";
import { WizardProvider } from "./modules/wizard/context";
import { NotifyProvider } from "./modules/notify/context";
import { loadRecaptchaEnterprise } from "./utils/loadRecaptcha";

if (process.env.NODE_ENV === "production")
  GoogleAnalytics.initialize("UA-170279406-1");

const queryConfig: ReactQueryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 1,
    staleTime: 600000,
  },
};

const App = () => {
  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY!;

  useEffect(() => {
    loadRecaptchaEnterprise(SITE_KEY).catch(console.error);
  }, []);
  return (
    <Router>
      <Switch>
        <ReactQueryConfigProvider config={queryConfig}>
          <AppProvider>
            <NotifyProvider>
              <AuthProvider>
                <CssBaseline />
                <MuiThemeProvider theme={publicTheme}>
                  <WizardProvider>
                    <Public prefix="/" />
                  </WizardProvider>
                </MuiThemeProvider>

                <MuiThemeProvider theme={dashboardTheme}>
                  <WizardProvider>
                    <Dashboard prefix="/0" />
                  </WizardProvider>
                </MuiThemeProvider>
              </AuthProvider>
            </NotifyProvider>
          </AppProvider>
        </ReactQueryConfigProvider>
      </Switch>
    </Router>
  );
};

export default App;
